<template>
  <div class="card">
    <!-- Desktop Grid Layout -->
    <div class="insights-grid">
      <Card 
        v-for="insight in insightsData" 
        :key="insight.title"
        class="insights-card"
      >
        <template #header>
          <img 
            class="progress-img" 
            :src="insight.image" 
          >
        </template>
        <template #title>
          <p class="insights-card-title">
            {{ insight.title }}
          </p>
        </template>
        <template #content>
          <div>
            <span class="insights-card-info">{{ insight.percentage }}%</span>
          </div>
        </template>
      </Card>
    </div>

    <!-- Mobile Carousel -->
    <Carousel
      :value="insightsData"
      :num-visible="1"
      :num-scroll="1"
      :autoplay-interval="2000"
      :show-indicators="false"
      class="insights-carousel-mobile"
    >
      <template #item="slotProps">
        <Card class="insights-card">
          <template #header>
            <img 
              class="progress-img" 
              :src="slotProps.data.image" 
            >
          </template>
          <template #title>
            <p class="insights-card-title">
              {{ slotProps.data.title }}
            </p>
          </template>
          <template #content>
            <div>
              <span class="insights-card-info">{{ slotProps.data.percentage }}%</span>
            </div>
          </template>
        </Card>
      </template>
    </Carousel>
  </div>
</template>

<script>
import { Card } from "primevue";
import Carousel from "primevue/carousel";

export default {
  components: {
    Card,
    Carousel,
  },
  props: {
    newVocPercentage: {
      type: Number,
      required: true,
    },
    reviewedVocPercentage: {
      type: Number,
      required: true,
    },
    rememberedVocPercentage: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isMobile: window.innerWidth <= 599,
    };
  },
  computed: {
    insightsData() {
      return [
        {
          title: "New",
          image: require("../../assets/images/growing-seed.png"),
          percentage: this.newVocPercentage,
        },
        {
          title: "Reviewed",
          image: require("../../assets/images/plant.png"),
          percentage: this.reviewedVocPercentage,
        },
        {
          title: "Remembered",
          image: require("../../assets/images/fruits.png"),
          percentage: this.rememberedVocPercentage,
        },
      ];
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 599;
    },
  },
};
</script>

<style scoped>
.card {
    border-radius: 10px;
    margin-bottom: 3rem;
    width: 100%;
}

.insights-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    width: 100%;
}

@media (max-width: 599px) {
  .insights-grid {
    display: none;
  }
}

.insights-carousel-mobile {
    width: 100%;
    padding: 4px 0;
    display: none;
}

@media (max-width: 599px) {
  .insights-carousel-mobile {
    display: block;
  }
}

.calendar {
    width: 80%;
    align-items: center;
    align-content: center;
    align-self: center;
    margin: 20px;
    display: inline-block;
}

.progress-img {
    height: 40px;
    width: 40px;
    margin-top: 35px;
}

.insights-card {
    height: 200px;
    width: 95%;
    margin: 4px auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 12px;
}

@media (max-width: 599px) {
  .insights-card {
    width: 100%;
    margin: 0;
  }
}

.insights-card-title {
    font-size: 14px;
    text-align: center;
    margin: 8px 0;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--color-text-primary);
    font-family: var(--font-family);
    line-height: 1.3;
}

.insights-card-info {
    font-size: 28px;
    text-align: center;
    margin: 8px 0;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
}
</style>
